import ProjectUtil from './project-util';

class TrayExpand {
	static getDetailsMaxHeight($expandWrap) {
		if ($expandWrap && $('.expanded-details', $expandWrap).length) {
			return $('.expanded-details', $expandWrap).innerHeight();
		}
		// no value, return error code
		return -1;
	}

	static setDetailsMaxHeight($expandWrap, tMinHeight) {
		if ($expandWrap && $('.expanded-details', $expandWrap).length) {
			$expandWrap.css({ maxHeight: $('.expanded-details', $expandWrap).innerHeight() + 'px', minHeight: tMinHeight + 'px' });
		}
	}

	static expand($expandWrap, $contentTrayWrap, tMinHeight) {
		tMinHeight = (typeof tMinHeight !== 'undefined') ? tMinHeight : 0;
		// make expandTray visible
		$expandWrap.addClass('updating');
		// allow the max-height to transition
		this.setDetailsMaxHeight($expandWrap, tMinHeight);
		if ($contentTrayWrap && $contentTrayWrap.length) {
			// show content tray
			$contentTrayWrap.addClass('showing');
			// make content links tabbable
			$expandWrap.find('a').attr('tabindex', '0');
			// make expand content screen-reader visible
			$expandWrap.attr('aria-hidden', 'false')
				// mark as expanded
				.data('state', 'expand');
		}
		// when transition is done, add a class to remove max-height for page resizing
		setTimeout(function () {
			if ($expandWrap.data('state') === 'expand') {
				// expandded content is now showing
				$expandWrap.addClass('showing')
					// no longer updating
					.removeClass('updating');
				// focus!
				$expandWrap.find('.focus-target').focus();

			}
			// update scrollReveal positions
			ProjectUtil.pubSub.trigger('scrollRevealRefresh');
			$(window).resize();
			// update lazyLoader images
			ProjectUtil.lazyLoader.update();
			// if there is a data-event-name property, fire the event
			if ($expandWrap.data('event-name')) {
				ProjectUtil.pubSub.trigger('trayExpand', { action: 'expand', id: $expandWrap.data('event-name') });
			}
		}, 500);
	}

	static collapse($expandWrap, $contentTrayWrap) {
		// update maxHeight
		this.setDetailsMaxHeight($expandWrap, 0);
		// mark as collapsed
		$expandWrap.data('state', 'collapse');
		ProjectUtil.onNextFrame(function () {
			// remove showing now that the new max height has been set
			$expandWrap.addClass('updating').removeClass('showing').attr('aria-hidden', 'true');
			// make content links not tabbable
			$expandWrap.find('a').attr('tabindex', '-1');
			// remove max-height in next animation frame, so this doesn't snap up
			ProjectUtil.onNextFrame(function () {
				$expandWrap.css({ maxHeight: '', minHeight: '' });
				$contentTrayWrap.removeClass('showing');
			});
		});
		// when transition is done, update
		setTimeout(function () {
			$expandWrap.removeClass('updating');
			ProjectUtil.pubSub.trigger('scrollRevealRefresh');
			// if there is a data-event-name property, fire the event
			if ($expandWrap.data('event-name')) {
				ProjectUtil.pubSub.trigger('trayExpand', { action: 'collapse', id: $expandWrap.data('event-name') });
			}
		}, 500);
	}
}
export default TrayExpand;